export const BUS_CONFIG = {
  'moonshot': {
    btnLink: '/wk-api/wenkoo-tenant/custom/moonShot/microsoftLogin',
  },

  'shzylib': {
    btnLink: '/wk-api/wenkoo-tenant/custom/shzylib/redirectLogin',
  },

  'default': {
    btnLink: '/chat/',
  }
}

export enum AI_ROLE_TYPE {
  WENKEAI3 = 1,
  WENKEAI4 = 2,
  WENXIN = 3,
  WENXIN4 = 4,
  SPARK = 5, // 讯飞星火
  QWENMAX = 6, // 通义千问
  KIMI = 7, // kimi
  HUNYUAN = 8,
  HUNYUANS = 9,
  DEEPSEEKR1 = 10,
  DEEPSEEKV3 = 11,
  YIGE = 101,
  COZE = 201,
  CHATPPT_TEXT = 202,
  CHATPPT_TOPIC = 203,
  CHATPPT_STEP = 204,
  SYSTEM,
  USER,
}

export const AI_ROLE = [
  {
    title1: '文心一言 4.0',
    title: 'models.wenxin4',
    id: AI_ROLE_TYPE.WENXIN4,
  },
  {
    title: 'models.wenxin3',
    title1: '文心一言',
    id: AI_ROLE_TYPE.WENXIN,
  },
  {
    title1: 'DeepSeek',
    title: 'models.deepseekv3',
    id: AI_ROLE_TYPE.DEEPSEEKV3,
  },
  {
    title1: 'DeepSeek R1',
    title: 'models.deepseekr1',
    id: AI_ROLE_TYPE.DEEPSEEKR1,
  },
  {
    title1: 'Kimi',
    title: 'models.kimi',
    id: AI_ROLE_TYPE.KIMI,
  },
  {
    title1: '文可模型',
    title: 'models.gpt3',
    id: AI_ROLE_TYPE.WENKEAI3,
    model: 'gpt-3.5-turbo-16k',
  },
  {
    title1: '文可模型-Plus版',
    title: 'models.gpt4',
    id: AI_ROLE_TYPE.WENKEAI4,
    model: 'gpt-4',
  },
  {
    title1: '通义千问',
    id: AI_ROLE_TYPE.QWENMAX,
    title: 'models.tongyi',
  },
  {
    title1: '讯飞星火 3.0',
    title: 'models.xunfei',
    id: AI_ROLE_TYPE.SPARK,
  },
  {
    title1: '腾讯混元',
    title: 'models.hunyuan',
    id: AI_ROLE_TYPE.HUNYUAN,
  },
  {
    title1: '文心AI作图',
    id: AI_ROLE_TYPE.YIGE,
    title: 'models.yige',
  },
];
